const body = document.getElementsByTagName('body')[0];

export const removeDisconnectPopup = () => {
  document.querySelector('.chat-disconnected-background') ? document.querySelector('.chat-disconnected-background').remove() : '';
}

const listenForCloseEvent = () => {
  if (document.querySelector('.chat-disconnected-button')) {
    document.querySelector('.chat-disconnected-button').onclick = () => {
      removeDisconnectPopup();
    }
  }
}

export const chatDiconnectedPopup = () => {
  createPopup();
  listenForCloseEvent();
};

const createPopup = () => {
  console.info('Something went wrong with chat.');
  return;

  let popup = '';
  popup = document.createElement('div');
  popup.classList.add('chat-disconnected-background');

  popup.innerHTML = 
    `<div class="chat-disconnected-holder" >
      <div class="chat-diconnected-popup" >
        <div class="chat-disconnected-divider" >
          <span class="chat-diconnected-header" >
            Something went wrong
          </span>
          <span class="chat-diconnected-message" >
            An error occured while connecting to the server
          </span>
        </div>
        <div class="chat-disconnected-divider lower" >
          <div class="chat-disconnected-button">
              OK
          </div>
        </div>
      </div>
    </div>`;

  body.appendChild(popup);
}



//////////////////
// WEBPACK FOOTER
// ./src/ui/js/chat-warning.js
// module id = 133
// module chunks = 13